import { IFilterItem } from '../../types';

export function parseFilterOptions(filterOptions: IFilterItem[]) {
  return filterOptions.map(option => ({
    label: option.description,
    value: option.key.toLocaleUpperCase()
  }));
}
